<template>
    <div class="relative-position">
        <status-overlay :action="loadingAction" content-height="100px" class="center-overlay"></status-overlay>
    <v-card v-if="eventAttendees && eventAttendees.length" class="pa-3">
        <v-card-title >
            <h2 class="who-is-coming-title">
                {{whoIsComingConstants.TITLE}}
            </h2>
        </v-card-title>
        <v-layout row align-end justify-space-between class="event-search-bar">
        <v-flex xs12 sm6 md6 lg3 pa-2 class="search-field">
            <v-text-field
                    data-qe-id="event-attendees__search-field"
                    clearable
                    v-model="search"
                    append-icon="search"
                    :label= "whoIsComingConstants.SEARCH_ATTENDEES"
                    single-line
                    @keyup="filterEventAttendees"
                    hide-details
            >
            </v-text-field>
        </v-flex>
        </v-layout>
        <v-data-table
                must-sort
                data-qe-id="event-attendees__table"
                :headers="headers"
                :items="localEventAttendees"
                :pagination.sync="pagination"
                :rows-per-page-items="[25, 50, 100,250]"
                class="who-is-coming"
                sort-icon="fa fa-caret-square-down"
        >

            <template slot="items" slot-scope="props" data-qe-id="event-attendees__table-items" >
                    <td>{{ props.item.displayName}}</td>
                    <td>{{ props.item.primaryChapterName }}</td>
                    <td>{{ props.item.primaryRegionName}}</td>
                    <td>{{ props.item.companyName }}</td>
            </template>

            <template v-slot:no-results data-qe-id="event-attendees__no-result-found">
                <v-alert :value="true" color="error" icon="warning">
                    {{noResultFound(search)}}
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
    </div>
</template>

<script>
    import { whoIsComingConstants, noResultFound } from "./EventAttendees.constants";
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import StatusOverlay from "../StatusOverlay/StatusOverlay";

    export default {
        name: 'EventAttendees',
        components: {
          StatusOverlay,
        },
        created() {
            const eventId = this.$route.query.eventId || '4DCF37A335864B5796BBEABFEE939305';
            this.getEventAttendeesFromApi(eventId)
                .then(() => {
                    this.localEventAttendees = [...this.eventAttendees];
                });
            },
        data() {
            return {
                whoIsComingConstants,
                search: '',
                headers: whoIsComingConstants.columns,
                pagination: {
                    rowsPerPage: 25,
                    page: 'number',
                },
                noResultFound,
                localEventAttendees: [],
            };
        },
        methods: {
          ...mapActions({
              getEventAttendeesFromApi: `eventAttendees/${storeAction.getEventAttendees}`,
          }),
            filterEventAttendees() {
              if (this.search) {
                  const searchLowerCase = this.search.toLowerCase();
                  this.localEventAttendees = this.eventAttendees
                      .filter(event =>
                      (event.displayName.toLowerCase().includes(searchLowerCase)
                      || (event.primaryChapterName && event.primaryChapterName.toLowerCase().includes(searchLowerCase))
                      || (event.primaryRegionName && event.primaryRegionName.toLowerCase().includes(searchLowerCase))
                      || (event.companyName && event.companyName.toLowerCase().includes(searchLowerCase))));
              } else {
                  this.localEventAttendees = [...this.eventAttendees];
              }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                eventAttendees: `eventAttendees/${storeGetters.eventAttendees}`,
            }),
            loadingAction() {
                return this.actions[storeAction.getEventAttendees];
            },
        },
    };

</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .who-is-coming {
        position: relative;
        tbody {
            tr:nth-of-type(odd) {
                background-color: $ypo-light-gray;
            }

            tr:hover {
                background-color: $ypo-medium-gray !important;
            }

            tr > td {
                font-family: "Raleway", sans-serif !important;
                font-size: inherit;
            }
        }

        thead > tr > th {
            font-family: "Raleway", sans-serif !important;
            color: $ypo-cta !important;
            font-weight: 600 !important;
            font-size: inherit;
            width: 25%;
            i{
                font-size: 12px !important;
                margin-left: 3px;
                margin-bottom: 1px;
                color: $ypo-gray !important;
            }
        }

        .v-datatable.v-table.theme--light .v-datatable__actions__range-controls > div {
            position: absolute;
            top: -25px;
            right: 10px;
            margin: 0;
            font-size: 14px;
        }

        .v-datatable.v-table.theme--light .v-datatable__actions__range-controls > div::after {
            content: ' attendees';
        }

        .v-datatable.v-table.theme--light .v-datatable__actions__range-controls > div::before {
            content: ' Showing ';
        }
    }

</style>

<style scoped lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .event-search-bar {
        background-color: $ypo-light-gray;
    }
    @include breakpoint(xs) {
        .search-field {
            margin-bottom: 20px;
        }
    }
    .who-is-coming-title {
        margin-bottom: 40px;
    }

    .who-is-coming-title::before {
        content: '';
        border-left: 3px solid $ypo-black-opac;
        border-radius: 2px;
        padding: 4px;
    }
    .center-overlay {
       margin-top: calc(100vh - 50vh);
    }

</style>
